import { Outlet } from 'react-router-dom';

import { ExploreSidebar } from '@/components/layout/Explore/ExploreSidebar';

export function ExploreLayout() {
  return (
    <div className="flex flex-1 min-w-0 overflow-hidden">
      <ExploreSidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
